import styled from "styled-components";
import { DefaultTitleLargeFactory } from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const ContactSectionFormContainer = styled.section(
  ({ theme, $isOpen }) => ({
    backgroundColor: theme.color.neutral["08"],
    borderBottom: `1px solid ${theme.color.line.medium}`,
    marginBottom: "0 !important",
    paddingTop: $isOpen ? "40px" : 0,
    paddingBottom: $isOpen ? "40px" : 0,
    maxHeight: $isOpen ? "900px" : 0,
    overflow: "hidden",
    transition: "all .5s ease",

    [theme.breakpoint.lg()]: {
      paddingTop: $isOpen ? "60px" : 0,
      paddingBottom: $isOpen ? "60px" : 0,
    },
  })
);

export const ContactSectionFormContent = styled.form(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
}));

export const ContactSectionFormTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const ContactSectionFormData = styled.div(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: "24px 60px",

  [theme.breakpoint.lg()]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
}));

export const ContactSectionFormFooter = styled.footer(({ theme }) => ({
  display: "flex",
  flexDirection: "column-reverse",
  gap: "20px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
}));
